import React from "react";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import SetMealIcon from "@mui/icons-material/SetMeal";

const Banner = () => {
  return (
    <Box marginTop={{ xs: "20%", sm: "5%" }}>
      <Box alignItems={"center"} width={"100%"}>
        <Typography
          variant={"h3"}
          fontWeight={700}
          textAlign={"center"}
          color={"#fff"}
        >
          Our Services
        </Typography>
        <Stack
          spacing={2}
          width={{ xs: "100%", sm: "35%" }}
          paddingTop={{ xs: "5%", sm: "1%" }}
        >
          <Breadcrumbs
            separator={
              <SetMealIcon
                fontSize="medium"
                sx={{
                  color: "#fff",
                }}
              />
            }
            aria-label="breadcrumb"
          >
            <Link
              underline="hover"
              fontWeight={700}
              key="1"
              href="/"
              sx={{
                color: "#fff",
                fontSize: "18px",
                "&:hover": { color: "#00AEEF" },
              }}
            >
              Home
            </Link>
            <Link
              underline="hover"
              fontWeight={700}
              key="1"
              href="/our-services"
              sx={{
                color: "#fff",
                fontSize: "18px",
                "&:hover": { color: "#00AEEF" },
              }}
            >
              Our Services
            </Link>
            <Link
              underline="hover"
              fontWeight={700}
              key="1"
              href="/our-services/technical-department"
              sx={{
                color: "#00AEEF",
                fontSize: "18px",
                "&:hover": { color: "#fff" },
              }}
            >
              Technical Dept.
            </Link>
          </Breadcrumbs>
        </Stack>
      </Box>
    </Box>
  );
};

export default Banner;
